var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DynamicForm',{attrs:{"value":_vm.configuration,"canUpdate":_vm.canUpdate,"className":"provider-configuration","required":false,"allowAddRemove":_vm.allowAddRemove},on:{"input":function($event){return _vm.updateConfig($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }